import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import { createPinia } from 'pinia';


const el = document.querySelector('#questionnaire-app');

if (el) {
  const mode =  el.dataset.mode ?? 'form'; 
  const marketingPhone =  el.dataset.marketingPhone == 1 ? true :  false; 
  const marketingMail =  el.dataset.marketingMail  == 1 ? true :  false;
  const redirect =  el.dataset.redirect  == 1 ? true :  false;
  const app = createApp(App, {
    mode ,
    marketingPhone,
    marketingMail,
    redirect
  })

  app.use(createPinia()).mount(el)
}